<app-shipment-system-simplenav></app-shipment-system-simplenav>
<div class="container-fluid">
    <div class="row">
        <div class="col-4 offset-4">
            <div class="d-flex flex-column flex-wrap gap-2 mt-3">
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol/shipment-control'">Kontrol</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol/picking-list'">Plukliste</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol/shipment-utilities'">End of Day</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol/shipment-control'" [queryParams]="{dbMode: true}">Søg vare</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol/shipping-system-search'">Søg forsendelse</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol/shipping-system'">Forsendelser</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/shipment-help'">Info</a>
                <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/shipment-calculator'">Fragtberegner</a>
            </div>
        </div>
    </div>
</div>
